export const ON = 'On';
export const OFF = 'Off';
